import { render, staticRenderFns } from "./ontologi.vue?vue&type=template&id=6830bae9&"
import script from "./ontologi.vue?vue&type=script&lang=js&"
export * from "./ontologi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports